import React from 'react';
import style from "./RadioGroup.module.scss";

class RadioGroup extends React.Component {
  render() {
    const { options, value, onChange, containerClass, itemClass } = this.props;
    return (
        <div className={`d-flex flex-wrap ${style.item_container} ${containerClass}`}>{
          options.map((option, index) => {
            return (
                <div key={index} className={`d-flex justify-content-center align-items-center ${style.item} ${value === option.value ? style.checked : ''} ${itemClass}`} onClick={() => onChange(option.value)}>
                  <label>{option.label}</label>
                </div>
            )
          })
        }</div>
    );
  }
}

export default (RadioGroup);
